<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Predelovalci</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            />
          </div>
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
     <div class="columnBar">
        Skriti stolpci:
              <kendo-multiselect 
                        :data-source="columns"
                        :data-text-field="'title'"
                        :data-value-field="'field'"
                        :placeholder="'Skrij stolpce'"
                         @select="skrijStolpec"
                        @deselect="prikaziStolpec"
                        :filter="'contains'"
                        :auto-width="true"
                        :value="hiddenColumns"
                        >
            </kendo-multiselect>
        </div>

               <div class="grid-wrapper">
    <Grid  
                       
                        :sortable="sortable"
                        :filterable="filterable"
                        :groupable="groupable"
                        :pageable="{ buttonCount: 4, pageSizes: [10,50,100] }"
                        :data-items="dataResult"
                        :skip="skip"
                        :take="take" 
                        :sort="sort" 
                        :pageSize="pageSize"
                        :filter="filter" 
                        :columns="columns"
                        @datastatechange="dataStateChange"
                        @pagechange="pageChangeHandler"
                       :resizable="true"
                        
                  
                       
                        >
                     <template v-slot:cbItem="{props}">
                      <cbItem :checked="props.dataItem.jeaktivna"/>
                    </template>
                    <template v-slot:ukaziItem="{props}">
                      <PredelavaUkazi :dataItem="props.dataItem" :key="props.dataItem.id"/>
                    </template>
                        <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                     
                               <button 
                                title="Išči"
                                class="k-button k-primary"
                                @click="naloziPodatke"
                            >
                                Išči
                            </button>
                             <button v-if="userDetails.pravice.includes('PREDELAVA_PISI')"
                                title="Dodaj KMG"
                                class="k-button k-primary"
                                @click="dodajPredelovalca"
                            >
                                Dodaj
                            </button>
                             <button
                                title="Izvozi v Excel"
                                class="k-button k-primary"
                                @click="exportExcel"
                            >
                                Izvozi v Excel
                            </button>
                           
                        </div>
                            
                        </toolbar>
                    </Grid>
                    <div class="shema-loader" v-if="loading"><font-awesome-icon icon="circle-notch" spin="spin"/></div>
                    </div>
                    </div>
    </div>

</template>

<script>
import { mapState, mapActions,mapMutations } from 'vuex'

import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';


import { Grid, GridToolbar,GridNoRecords } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
//import { saveExcel } from '@progress/kendo-vue-excel-export';
import { MultiSelect } from '@progress/kendo-dropdowns-vue-wrapper';
import CheckBoxGridItem from './support/CheckBoxGridItem';
Vue.component('kendo-multiselect', MultiSelect);

import { process } from '@progress/kendo-data-query';

import PredelavaUkazi from './support/PredelavaUkazi';






export default {
     props:["sezona"],
      components:{
      'dropdownlist': DropDownList,
      'cbItem': CheckBoxGridItem,
      'PredelavaUkazi':PredelavaUkazi,
  //    'sifkontroleddcell': SifrantKontroleDownCell,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
 
  },
    data () {
        return {
            dataSezona:this.sezona,
            loading:false,
          
           
            girdDataApi:null,
            gridData:null,


             
            editID: null,
            skip: 0,
            take: 10,
            pageSize: 10,
            sortable: true,
            filterable: true,
            groupable: false,
            
            expandedItems: [],
            dataResult: [],
         
            sort: [
                { field: 'ime', dir: 'asc' }
            ],
           

           

        }
    },
    created () {

         
      if(!this.sezona)
      this.dataSezona={sezona:Math.max(...this.sezonePisanje.map(s=>s.sezona))};
      else
      this.dataSezona={sezona:this.sezona};

        
            


        
    
     //this.load(this.dataSezona);
     



    },
    computed: {
        filter:{
            get(){
                return this.storedfilter;
            },
            set(value){
                this.updatefilter(value);
            }
        },
        ...mapState('predelava', ['predelava','storedfilter']),
        ...mapState('users', ['userDetails','sezonePisanje']),
        hiddenColumns() {
            return this.columns.filter(c=>c.hidden);
        },
        columns() {

            let columns=[
                
                { field: "naziv", title:"Naziv"},
                //{ field: "kmgmid", title:"KMG-MID"},
                { field: "kontrolnastevilka", title:"Kontrolna št."},
                { field: "naslov", title:"Naslov",},
                { field: "postnastevilka", title:"Poštna št."},
                { field: "posta", title:"Pošta"},
                { field: "obcina", title:"Občina",hidden:true},
                { field: "statisticnaregija", title:"Statistična regija"},
                //{ field: "naslovnosilca", title:"Naslov nosilca",hidden:true},
                //{ field: "postnastevilkanosilca", title:"Poštna št. nosilca",hidden:true},
                //{ field: "postanosilca", title:"Pošta nosilca",hidden:true},
                { field: "glavnadejavnost", title:"Glavna dejavnost"},
                { field: "statuspredelovalca", title:"Status"},
                { field: "vrstapredelovalca", title:"Vrsta"},
                //{ field: "datumdolocitvestatusa", title:"Datum določitve statusa", filterable:false, type:"date",format: '{0:d}', hidden:true},
                //{ field: "ds", title:"Davčna številka",hidden:true},
                //{ field: "emso", title:"Emšo",hidden:true},
                //{ field: "vrstapredelovalca", title:"Vrsta predelovalca",hidden:true},
              //  { field: "imavezanezivali", title:"Vezana reja",hidden:true},
                //{ field: "imatravojedezivali", title:"Travojede živali",hidden:true},
                { field: "jeaktivna", title:"V kontroli",cell:"cbItem", hidden:true},
                
                
            ];

            if(this.userDetails.pravice.includes("PREDELAVA_PISI"))
                columns.unshift({ title: "Ukazi", cell: 'ukaziItem',filterable:false,columnMenu: null,width:"270px",sortable:false});

            if(this.userDetails.pravice.includes("STATISTIKA_BERI"))
                columns.push({ field: "kontrolnaorganizacija", title:"V kontroli pri"});




            return columns;


        }

           },
      watch: {
        skip(newValue, oldValue){
           

            const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.predelava, dataState);
        },
        take(newValue, oldValue){
         
       /*  if(isNaN(this.take))
            this.take=this.predelava.length;
         */   
            const dataState = {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                 filter: this.filter,
                group: this.group
            }
        this.dataResult = process( this.predelava, dataState);
        },
       predelava(newValue, oldValue) {
    

      if(newValue){
        const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.predelava, dataState);
        }
    }
},
    methods: {
        naloziPodatke: async function(e){
            this.loading=true;
            if(!this.sezona){
                this.dataSezona={sezona:Math.max(...this.sezonePisanje.map(s=>s.sezona))};
                this.sezona=this.dataSezona.sezona;
            }
            else
                this.dataSezona={sezona:this.sezona};
        this.load(this.dataSezona).then(()=>this.loading=false);
        },
        ...mapActions('predelava', ['load','replace']),
        ...mapMutations('predelava',['updatefilter']),

         skrijStolpec: function(e) {
            let column=this.columns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=true;
                const dataState = {
            skip: this.skip,
            take: this.take,
             filter: this.filter,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.predelava, dataState);
           
        },
        prikaziStolpec: function(e) {
           let column=this.columns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=false;
                const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.predelava, dataState);
        },
        sezonaChange(event) {
            const sezona = event.value;
            this.$router.push({ name: 'predelava', params: { sezona:sezona.sezona} })
            this.dataSezona=sezona;
            //this.load({sezona:this.dataSezona.sezona});
            
     


        },

        
        createAppState: function(dataState) {
           
            this.take = dataState.take;
            this.skip = dataState.skip?dataState.skip:0;
            if (dataState.group) {
                dataState.group.map(group => group.aggregates = this.aggregates);
            }
            this.group = dataState.group;
            this.filter = dataState.filter;
            this.sort = dataState.sort;
           
        },

        dataStateChange (event) {
            this.createAppState(event.data);
          
            this.dataResult = process(this.predelava, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });
          

        },
        formatDate: function (h, emptyElement , props, listeners ) {
          
             return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
        dodajPredelovalca(){

              this.$router.push({ name: 'dodajPredelovalca', params: this.dataSezona })

        },
        exportExcel () {
            
            this.saveExcel({
                data: process(this.predelava, {
                
                sort: this.sort,
                filter: this.filter,
                group: this.group
            }).data,
                fileName:this.dataSezona.sezona+ "_PREDELOVALCI",
                columns: this.columns.filter(i=>!i.hidden)
            });
        },

         pageChangeHandler: function(event) {
            
            this.skip = event.page.skip;
            this.take = event.page.take;
           
        },
        filterchange: function(ev) {

            this.updatefilter(ev);
        },
        
    }
};
</script>

